// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")
require('jquery')

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import '../stylesheets/application.scss'
import '../images/favicon.ico'
require.context('../images/', true)

import '../javascripts/application/application'
import '../javascripts/application/form_validation'
import '../javascripts/application/modal'
import '../javascripts/application/search'
import '../javascripts/application/areamap'
import '../javascripts/application/viewed_jobs'
import '../javascripts/application/interview_carousel'
import '../javascripts/application/job_media_carousel'
import '../javascripts/application/toggle_faq'
import '../javascripts/application/toggle_area_accordion'
import '../javascripts/application/header_menu'
import '../javascripts/application/toggle_search_lq'
import '../javascripts/application/local_fixed_cta'
import '../javascripts/application/local_scroll'

//custom
